<template>
  <div class="page_ blue_">
    <span class="top_ab hover_bold" @click="visibleDes = true">{{
      $t("wordsDes[2]")
    }}</span>
    <a-row class="steps">
      <a-col :span="8" v-for="item in steps" :key="item.step">
        <div class="step_item" :class="{ blue: item.process }">
          <img :src="item.icon" alt="" />
          <span style="margin-left: 13px;">{{ item.text }}</span>
          <span class="arrow_" :class="{ arrow_blue: item.arrowBlue }">{{
            item.arrow
          }}</span>
        </div>
      </a-col>
    </a-row>
    <!-- 理赔申请第二步 -->
    <div class="step_2" v-if="stepActive == 1">
      <div class="top_">
        <a-row style="display:flex;flex-wrap: wrap;">
          <a-col :span="7" class="flex_col">
            <span>{{ $t("InsuranceInfo[1]") || "保单号" }}：</span>
            <span>{{ policyObj.policyNo }}</span>
            <span class="arrow_icon" @click="policyChoose = true"></span>
          </a-col>
          <a-col :span="7" class="flex_col" :offset="1">
            <span>{{ $t("preAuth.insured") }}：</span>
            <a-select
              style="width:50%;border: 1px #eee solid;border-radius:4px;"
              @change="insuredChange"
              :defaultValue="policyObj.insured"
              v-if="insuredList.length > 1"
            >
              <a-select-option
                :value="item.empName"
                v-for="(item, index) in insuredList"
                :key="index"
                >{{ item.empName }}</a-select-option
              >
            </a-select>
            <div v-else-if="insuredList.length == 1">
              {{ insuredList[0].empName }}
            </div>
            <div v-else>{{ policyObj.insured }}</div>
          </a-col>
          <a-col :span="7" class="flex_col" :offset="1">
            <span>{{ $t("claim[7]") || "生效日期" }}</span
            >：
            <div>{{ policyObj.startDate }} - {{ policyObj.endDate }}</div>
          </a-col>
          <a-col
            :span="7"
            class="flex_col"
            v-if="policyObj && policyObj.cancellation == '1'"
          >
            <span>{{ $t("claim[54]") || "退保日期" }}</span
            >：
            <div>{{ policyObj.cancellationDate }}</div>
          </a-col>
          <a-col
            :span="7"
            class="flex_col"
            :offset="policyObj.cancellation == '1' ? '1' : '0'"
          >
            <span>{{ $t("preAuth.authCategory") }}：</span>
            <a-select
              :placeholder="$t('alertPrompt[19]')"
              style="width:50%;border: 1px #eee solid;border-radius:4px;"
              @change="categoryChange"
              :defaultValue="category"
            >
              <a-select-option
                :value="item.value"
                v-for="item in categoryList"
                :key="item.value"
              >
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="7" class="flex_col" :offset="1">
            <span>{{ $t("claim[11]") || "医疗机构" }}：</span>
            <a-select
              mode="default"
              label-in-value
              :autoClearSearchValue="false"
              optionLabelProp="children"
              show-search
              :value="value"
              :placeholder="$t('claim[12]') || '请输入医疗机构名称'"
              style="width: 65%;margin:0 7px 0 0;border: 1px solid #E7E7E7;border-radius:4px;"
              @blur="hospitalBlur"
              @search="fetch"
              @change="hospitalChange"
              :filter-option="true"
              :not-found-content="null"
            >
              <!-- <a-spin v-if="fetching" slot="notFoundContent" size="small" /> -->
              <a-select-option
                v-for="(d, index0) in fetchData"
                :key="index0 + 'hos'"
                :value="d.provider_name"
              >
                {{ d.provider_name }}
              </a-select-option>
            </a-select>
          </a-col>

          <a-col
            :span="7"
            class="flex_col"
            :offset="policyObj.cancellation == '1' ? '0' : '1'"
          >
            <span>{{ $t("preAuth.predate") }}：</span>
            <a-date-picker
              :placeholder="$t('preAuth.predate')"
              style="width:50%;"
              @change="onDateChange"
              :defaultValue="moment(date, 'YYYY-MM-DD')"
              :disabledDate="disabledDate"
              v-if="date"
            />
            <a-date-picker
              :placeholder="$t('preAuth.predate')"
              style="width:50%;"
              @change="onDateChange"
              :defaultValue="moment(moment().add(1, 'days'), 'YYYY-MM-DD')"
              :disabledDate="disabledDate"
              v-else
            />
          </a-col>
          <a-col
            :span="7"
            class="flex_col"
            :offset="policyObj.cancellation == '1' ? '1' : '0'"
          >
            <span>{{ $t("preAuth.judge") }}：</span>
            <a-select
              mode="default"
              label-in-value
              :autoClearSearchValue="false"
              optionLabelProp="children"
              :value="judgevalue"
              :placeholder="$t('alertPrompt[22]')"
              style="width: 50%;margin:0 7px 0 0;border: 1px solid #E7E7E7;border-radius:4px;"
              :filter-option="true"
              :not-found-content="null"
              @blur="judgeBlur"
              @search="judgefetch"
              @change="judgeChange"
              showSearch
            >
              <a-select-option
                v-for="(d, index1) in fetchJudgeData"
                :key="index1 + '_judge'"
                :value="d.name"
              >
                {{ d.name }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="7" class="flex_col" :offset="1">
            <span>{{ $t("preAuth.medicalPay") }}：</span>
            <a-input
              :placeholder="$t('alertPrompt[21]')"
              style="width:50%;border: 1px #eee solid;"
              v-model="estBills"
            >
            </a-input>
          </a-col>
          <a-col
            :span="7"
            class="flex_col"
            :offset="policyObj.cancellation == '1' ? '0' : '1'"
            v-if="category == 'IP'"
          >
            <span>{{ $t("preAuth.inHospitalTime") }}：</span>
            <a-input
              :placeholder="$t('alertPrompt[20]')"
              style="width:50%;border: 1px #eee solid;"
              v-model="estLos"
            >
            </a-input>
          </a-col>
        </a-row>
      </div>
      <div class="bottom_">
        <span class="remark_">
          {{ $t("claim[39]") || "备注" }}
          <span style="font-weight: 400;font-size: 14px;">{{
            $t("extra[0]") || "如果预估医疗费用的币种非人民币，请您备注"
          }}</span></span
        >
        <a-textarea
          style="margin-top: 17px;border-radius:4px;"
          :rows="4"
          v-model="remark"
          :placeholder="
            $t('alertPrompt[7]') || '请输入您对预授权的其他要求（125字以内）'
          "
        />
      </div>
      <a-row type="flex" justify="end" style="margin-top: 20px;">
        <a-button
          type="primary"
          style="margin-right: 20px;width:90px;border-radius:2px;"
          @click="next(1)"
          >{{ $t("claim[5]") || "下一步" }}</a-button
        >
      </a-row>
    </div>
    <!-- 理赔申请第三步 -->
    <div class="step_3" v-else-if="stepActive == 2">
      <p style="padding: 0 59px 0 30px;">
        {{
          $t("claim[51]") ||
            "为了顺利通过审核，请提供以下材料，有圆点的为必传项"
        }}
      </p>
      <a-row
        style="margin-top: 20px;padding: 0 59px 0 30px; display:flex;flex-wrap:wrap;"
      >
        <a-col
          :span="7"
          v-for="(item, index) in fileList"
          :key="index"
          :offset="index % 3 == 0 ? '0' : '1'"
          style="margin-bottom:30px;"
        >
          <a-row type="flex" justify="space-between" align="middle">
            <a-col style="max-width:70%;display:flex;align-items:center;">
              <img
                v-if="item.isFill == '1'"
                class="cicle"
                src="../assets/medilinkPC/cicle.png"
                alt=""
              />
              <span
                class="tit tit1"
                style="font-weight:bold"
                :title="$i18n.locale == 'zh-cn' ? item.cName : item.eName"
                >{{ $i18n.locale == "zh-cn" ? item.cName : item.eName }}</span
              ></a-col
            >
            <a-col style="min-width:70px;text-align:right;">
              <a
                @click="downFile"
                style="margin-left: 10px;white-space:nowrap;"
                class="hover_bold"
                v-if="item.type == 'EL'"
                >{{ $t("InsuranceInfo[30]") || "下载" }}</a
              >
              <a
                href="javascript:;"
                class="hover_bold"
                v-if="language == 'CHINAESE' && item.type != 'EL'"
                @click="exam(index)"
                >{{ $t("claim[52]") || "示例" }}</a
              >
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col
              style="display:flex;align-items:flex-start;font-size:13px;margin-top:5px;width:100%"
            >
              <span class="icon_info" v-if="item.cNote"></span>
              <span
                class="tit tit2"
                style="color: #999999;"
                :title="$i18n.locale == 'zh-cn' ? item.cNote : item.eNote"
                >{{ $i18n.locale == "zh-cn" ? item.cNote : item.eNote }}</span
              >
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8" class="addlist">
              <div
                class="list-item"
                v-for="(item2, index2) in uploadFileList"
                :key="index2"
              >
                <div v-if="item2.imageType == item.type" class="flex_n">
                  <span :title="item2.imageName">{{ item2.imageName }}</span>
                  <span class="remove" @click="removeFile(index2)">x</span>
                  <a
                    @click="preview(index2)"
                    style="margin-left: 10px;"
                    class="hover_bold"
                    >{{ $t("claim[42]") || "预览" }}</a
                  >
                </div>
              </div>
            </a-col>
          </a-row>
          <a-row class="mt_">
            <a class="hover_bold"
              ><span class="downicon"></span
              ><input
                @change="uploadPhoto($event, item.type)"
                type="file"
                class="kyc-passin"
                style="opacity: 0;"
                title=""
                :id="item.id"
              />{{ $t("claim[53]") || "上传文件" }}</a
            >
          </a-row>
        </a-col>
      </a-row>
      <a-row
        type="flex"
        justify="end"
        style="padding-top: 20px;background: #F5F5F5;"
      >
        <a-button
          type="primary"
          style="margin-right: 20px;width:90px;border-radius:2px;"
          @click="next(2)"
          >{{ $t("claim[5]") || "下一步" }}</a-button
        >
        <a-button
          @click="preStep(2)"
          style="margin-right: 30px;width:90px;border-radius:2px;"
          >{{ $t("claim[38]") || "上一步" }}</a-button
        >
      </a-row>
    </div>
    <!-- 理赔申请第四步 -->
    <div class="step_2" v-else-if="stepActive == 3">
      <div
        class="top_"
        style="padding-left:29px;padding-right:29px;border-radius: 10px;"
      >
        <a-row>
          <a-col :span="6">
            {{ $t("InsuranceInfo[1]") || "保单号" }}：{{ policyObj.policyNo }}
          </a-col>
          <a-col :span="6">
            {{ $t("preAuth.insured") }}：{{ policyObj.insured }}
          </a-col>
          <a-col :span="6">
            {{ $t("claim[7]") || "生效日期" }}：{{ policyObj.startDate }} -
            {{ policyObj.endDate }}
          </a-col>
          <a-col :span="6">
            {{ $t("preAuth.authCategory") }}：{{
              category | filterData(categoryList)
            }}
          </a-col>
        </a-row>
        <a-row style="margin-top: 14px;">
          <a-col :span="6">
            {{ $t("claim[11]") || "医疗机构" }}：{{ hospitalName }}
          </a-col>
          <a-col :span="6"> {{ $t("preAuth.predate") }}：{{ date }} </a-col>
          <a-col :span="6">
            {{ $t("preAuth.judge") }}：{{ judgevalue.label }}
          </a-col>
          <a-col :span="6">
            {{ $t("preAuth.medicalPay") }}：{{
              $i18n.locale == "zh-cn" ? "" : "￥"
            }}{{ estBills }}{{ $i18n.locale == "zh-cn" ? "元" : "" }}
          </a-col>
        </a-row>
        <a-row style="margin-top: 14px;" v-if="category == 'IP'">
          <a-col :span="6">
            {{ $t("preAuth.inHospitalTime") }}：{{ estLos
            }}{{ $i18n.locale == "zh-cn" ? "天" : "day" }}
          </a-col>
        </a-row>
      </div>

      <div class="tables_">
        <div class="tit_" style="font-weight:bold">
          {{ $t("claim[40]") || "已提交材料" }}
        </div>
        <a-row
          style="margin-top: 20px;padding: 0 0px 0 0px; display:flex;flex-wrap:wrap;"
        >
          <a-col
            :span="7"
            v-for="(item, index) in fileList"
            :key="index"
            :offset="index % 3 == 0 ? '0' : '1'"
            style="margin-bottom:30px;"
          >
            <a-row type="flex" justify="space-between" align="middle">
              <a-col style="display:flex;align-items:center;">
                <img
                  v-if="item.isFill == '1'"
                  class="cicle"
                  src="../assets/medilinkPC/cicle.png"
                  alt=""
                />
                <span class="tit" style="font-weight:bold">{{
                  $i18n.locale == "zh-cn" ? item.cName : item.eName
                }}</span></a-col
              >
            </a-row>
            <a-row>
              <a-col
                class="addlist"
                style="display:flex;flex-direction:column;margin-top:10px;"
              >
                <div
                  class="list-item"
                  v-for="(item2, index2) in uploadFileList"
                  :key="index2"
                  style="width:100%;padding:0 15px;"
                >
                  <div v-if="item2.imageType == item.type" class="flex_n">
                    <span :title="item2.imageName">{{ item2.imageName }}</span>
                    <a
                      @click="preview(index2)"
                      style="margin-left: 10px;white-space:nowrap;"
                      class="hover_bold"
                      >{{ $t("claim[42]") || "预览" }}</a
                    >
                  </div>
                </div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
      <div class="bottom_" style="margin-bottom: 20px;">
        <span class="remark_" style="font-weight:bold">{{
          $t("claim[39]") || "备注"
        }}</span>
        <p style="margin-top: 17px;">{{ remark }}</p>
      </div>
      <a-row type="flex" justify="end" style="margin-top: 20px;">
        <a-button type="primary" style="margin-right: 20px;" @click="submit">{{
          $t("claim[49]") || "确认提交"
        }}</a-button>
        <a-button @click="preStep(3)">{{
          $t("claim[50]") || "返回修改"
        }}</a-button>
      </a-row>
    </div>
    <a-modal v-model="visible" :footer="null">
      <img :src="baseImg" alt="" style="width: 100%" />
    </a-modal>
    <a-modal v-model="imgVisible" :footer="null">
      <img
        :src="item.templateUrl"
        alt=""
        style="width: 100%"
        v-for="(item, index) in showImgList"
      />
    </a-modal>

    <div class="fixbg1" v-if="isLoading">
      <a-spin />
    </div>
    <a-modal v-model="policyChoose" :footer="null" class="modal_" width="70%">
      <div class="top_">
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" :tab="$t('InsuranceInfo[0]') || '有效保单'">
            <div class="list_p" v-if="effectivePolicyList.length > 0">
              <div
                v-for="(item, index) in effectivePolicyList"
                :key="index"
                style="margin-bottom: 20px;"
                class="item_p"
                :class="{ on: item.checked == true }"
                @click="checkPolicyNo(item, index, '0')"
              >
                <p class="tit_">
                  {{ $t("InsuranceInfo[1]") || "保单号" }}：{{ item.policyNo }}
                  <span class="check_"></span>
                </p>
                <div class="main_info_">
                  <p class="bold_">{{ item.description }}</p>
                  <p v-if="item.show != '1'">
                    {{ $t("InsuranceInfo[2]") || "主被保险人" }}：{{
                      item.empName
                    }}
                  </p>
                  <p v-if="item.show != '1'">
                    {{ $t("preAuth.serCard") }}：{{ item.cardNo }}
                  </p>
                  <div
                    v-for="(item2, index2) in item.depenList"
                    :key="index2"
                    v-if="item.depenList.length > 0"
                  >
                    <div class="con_">
                      <p class="mr_">
                        {{ $t("InsuranceInfo[9]") || "连带保险人" }}：{{
                          item2.empName
                        }}
                      </p>
                      <p class="mr_">
                        {{ $t("InsuranceInfo[5]") || "保险卡号" }}：{{
                          item2.cardNo
                        }}
                      </p>
                    </div>
                  </div>
                  <p>
                    {{ $t("InsuranceInfo[8]") || "保障有效期" }}：{{
                      item.startDate
                    }}
                    - {{ item.endDate }}
                  </p>
                  <p v-if="item.cancellation == '1'">
                    {{ $t("claim[54]") }}：{{ item.cancellationDate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="nodata" v-else>
              <img src="../assets/medilinkPC/nodata.jpg" alt="" />
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="2"
            :tab="$t('InsuranceInfo[10]') || '历史保单'"
            force-render
          >
            <div class="list_p" v-if="hisPolicyList.length > 0">
              <div
                v-for="(item, index) in hisPolicyList"
                :key="index"
                style="margin-bottom: 20px;"
                class="item_p"
                :class="{ on: item.checked == true }"
                @click="checkPolicyNo(item, index, '1')"
              >
                <p class="tit_">
                  {{ $t("InsuranceInfo[1]") || "保单号" }}：{{ item.policyNo
                  }}<span class="check_"></span>
                </p>
                <div class="main_info_">
                  <p class="bold_">{{ item.description }}</p>
                  <p v-if="item.show != '1'">
                    {{ $t("InsuranceInfo[2]") || "主被保险人" }}：{{
                      item.empName
                    }}
                  </p>
                  <p v-if="item.show != '1'">
                    {{ $t("preAuth.serCard") }}：{{ item.cardNo }}
                  </p>
                  <div
                    v-for="(item2, index2) in item.depenList"
                    :key="index2"
                    v-if="item.depenList.length > 0"
                  >
                    <div class="con_">
                      <p class="mr_">
                        {{ $t("InsuranceInfo[9]") || "连带保险人" }}：{{
                          item2.empName
                        }}
                      </p>
                      <p class="mr_">
                        {{ $t("InsuranceInfo[5]") || "保险卡号" }}：{{
                          item2.cardNo
                        }}
                      </p>
                    </div>
                  </div>
                  <p>
                    {{ $t("InsuranceInfo[8]") || "保障有效期" }}：{{
                      item.startDate
                    }}
                    - {{ item.endDate }}
                  </p>
                  <p v-if="item.cancellation == '1'">
                    {{ $t("claim[54]") }}：{{ item.cancellationDate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="nodata" v-else>
              <img src="../assets/medilinkPC/nodata.jpg" alt="" />
            </div>
          </a-tab-pane>
          <a-input
            slot="tabBarExtraContent"
            :placeholder="$t('InsuranceInfo[11]') || '请输入保单/保险卡号'"
            v-model="cardNo"
            @input="changeInput"
          >
            <!-- <a-icon slot="prefix" type="search"></a-icon> -->
            <img
              slot="prefix"
              src="../assets/medilinkPC/search.png"
              alt=""
            />
          </a-input>
        </a-tabs>
      </div>
    </a-modal>
    <a-modal
      v-model="visibleDes"
      class="modal_"
      :footer="null"
      :closable="false"
    >
      <div class="con_">
        <p class="title_">{{ $t("wordsDes[2]") }}</p>
        <p>{{ $t("wordsDes[3]") }}</p>
        <p>{{ $t("wordsDes[4]") }}</p>
        <p>{{ $t("wordsDes[5]") }}</p>
        <button @click="visibleDes = false">
          {{ $i18n.locale == "zh-cn" ? "知道了" : " I got it" }}
        </button>
      </div>
    </a-modal>
  </div>
</template>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.page_ {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  color: #394155;
  padding-bottom: 20px;
  position: relative;
  .steps {
    background-color: #fff;
    height: 55px;
    line-height: 55px;
    width: 100%;
    font-size: 16px;
    color: #cccccc;
    border-bottom: 1px #f3f3f3 solid;
    border-radius: 10px;
    .step_item {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 17px;
        height: 17px;
      }
      .arrow_ {
        position: absolute;
        right: 0;
        font-size: 20px;
        color: #cccccc;
      }
      .arrow_blue {
        color: #2c5acc;
      }
    }
    .blue {
      border-bottom: 3px #2c5acc solid;
      color: #2c5acc;
    }
    .arrow_blue {
      color: #2c5acc;
    }
  }
  .step_1 {
    background-color: #fff;
    padding-top: 137px;
    padding-left: 15%;
    padding-right: 15%;
    line-height: 24px;
    padding-bottom: 60px;
    .attention_ {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 14px;
    }
    .next_ {
      margin-top: 38px;
    }
  }
  .step_2 {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .top_ {
      padding: 38px 0 20px 29px;
      background-color: #fff;
      margin-bottom: 20px;
    }
    .card_ {
      width: 100%;
      border-radius: 10px;
      background-color: #fff;
      padding: 27px 29px 20px 29px;
      .account_ {
        margin-top: 16px;
        margin-bottom: 17px;
        position: relative;
        padding-left: 16px;
        .arrow_ {
          &::after {
            content: "";
            display: block;
            height: 0;
            width: 0;
            position: absolute;
            top: 7px;
            left: 0;
            border: 5px solid;
            border-color: #2c5acc transparent transparent transparent;
          }
          &.right_::after {
            top: 5px;
          }
        }
      }
      .add_ {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .foot_ {
        margin-top: 20px;
        padding-top: 17px;
        border-top: 1px #e7e7e7 solid;
        position: relative;
        &::after {
          content: "";
          display: block;
          height: 0;
          width: 0;
          position: absolute;
          top: 20px;
          left: 0;
          border: 5px solid;
          border-color: transparent transparent transparent #2c5acc;
        }
        &.right_::after {
          top: 5px;
        }
      }
      .card_info {
        margin-right: 22px;
      }
      .card_1 {
        color: #2c5acc;
        margin-top: 20px;
        width: auto;
        height: 30px;
        display: inline-block;
        padding: 0 10px;
        line-height: 30px;
        border-left: 3px #2c5acc solid;
        background: #fafafa;
        text-align: center;
        margin-bottom: 20px;
        font-weight: 500;
      }
      .modify_info {
        .mr_ {
          margin-right: 8px;
          margin-bottom: 10px;
          display: inline-block;
        }
      }
    }
    .bottom_ {
      height: 177px;
      width: 100%;
      border-radius: 10px;
      background-color: #fff;
      margin-top: 20px;
      padding: 26px 29px 35px 29px;
      .remark_ {
        font-weight: 500;
        font-size: 16px;
      }
    }
    .tables_ {
      width: 100%;
      background-color: #fff;
      padding: 27px 29px 0 29px;
      border-radius: 10px;
      .tit_ {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 25px;
      }
      .img_ {
        width: 10px;
        height: 10px;
        margin-right: 5px;
      }
      .mt_20 {
        margin-top: 20px;
      }
      .mt_10 {
        margin-top: 10px;
      }
    }
  }
  .step_3 {
    color: #394155;
    padding-top: 27px;
    // padding: 27px 59px 0 61px;
    background-color: #fff;
    .cicle {
      width: 10px;
      height: 10px;
    }
    .tit {
      font-weight: 500;
      &.tit1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 3px;
      }
      &.tit2 {
        height: 20px;
        overflow: hidden;
        display: block;
        width: 100%;
        max-width: 100%;
        margin-right: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .dec {
      margin-left: 10px;
      color: #999999;
    }
    .exp {
      margin-left: 10px;
    }
    .mt_ {
      margin-top: 10px;
      a {
        position: relative;
      }
      input {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
      }
    }
    .upload {
      position: relative;
      z-index: 999;
    }
    .addlist {
      width: 100%;
      height: 150px;
      overflow-y: auto;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-top: 16px;
      input {
        outline: none;
        border: none;
        margin: 20px;
        width: 90%;
      }
      .list-item {
        .remove {
          margin-left: 10px;
          color: #e5002d;
          font-size: 18px;
          cursor: pointer;
        }
        .blue {
          margin-right: 5px;
        }
        display: flex;
        align-items: center;
        padding: 0 5px;
      }
    }
  }
  .color_999 {
    color: #999;
  }
}
.flex_col {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  span {
    white-space: nowrap;
  }
}
.rule_ {
  display: flex;
  align-items: center;
  span {
    width: 15px;
    height: 15px;
    border: 1px solid #ccc;
    display: inline-block;
    border-radius: 15px;
    position: relative;
    min-width: 15px;
    margin-right: 10px;
    cursor: pointer;
    &.on {
      background: url(../assets/medilinkPC/checkiconr.png) center center
        no-repeat #2c5acc;
      background-size: 10px 10px;
      border-color: #2c5acc;
    }
  }
  a:hover {
    color: #2c5acc;
  }
}
.modal_ {
  .top_ {
    padding-top: 10px;
  }
  .con_ {
    max-height: 500px;
    overflow: hidden;
    overflow-y: scroll;
    font-size: 14px;
    button {
      border: none;
      background-color: #2c5acc;
      color: #fff;
      text-align: center;
      padding: 5px 20px;
      display: block;
      margin: 15px auto 0;
      border-radius: 5px;
      outline: 0;
    }
  }
  p {
    line-height: 25px;
    text-indent: 2em;
  }
  .title_ {
    font-weight: bold;
    text-align: center;
  }
  button.ant-btn-primary {
    background-color: #2c5acc;
  }
}
.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}
.list_p {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-height: 60vh;
  overflow: hidden;
  overflow-y: scroll;
  .con_ {
    overflow: unset;
  }
  .item_p {
    width: 30%;
    border: 1px solid #efefef;
    border-radius: 5px;
    padding-bottom: 10px;
    cursor: pointer;
    margin-right: 5%;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    p {
      text-indent: 0;
    }
    .tit_ {
      padding: 10px 10px;
      border-bottom: 1px solid #efefef;
      position: relative;
    }
    .main_info_ {
      padding: 0 10px;
      position: relative;
    }
    .bold_ {
      font-weight: bold;
      padding: 10px 0 0;
    }
    .check_ {
      width: 15px;
      height: 15px;
      position: absolute;
      right: 20px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      border: 1px solid #ccc;
      border-radius: 15px;
      background-color: #fff;
    }
    &.on .check_ {
      background: url(../assets/medilinkPC/checkiconr.png) center center
        no-repeat #2c5acc;
      background-size: 10px 10px;
      border-color: #2c5acc;
    }
  }
}
.arrow_icon {
  width: 20px;
  height: 20px;
  background: url(../assets/medilinkPC/downicon.png) center center no-repeat;
  background-size: 20px 20px;
  display: inline-block;
}
.nodata img {
  width: 100px;
  position: relative;
  display: block;
  margin: 50px auto 50px;
}
.blue_f {
  color: #2c5acc;
}
.top_ab {
  position: absolute;
  color: #2c5acc;
  top: -37px;
  right: 0;
  cursor: pointer;
}
.hover_bold:hover {
  font-weight: bold;
}
.icon_info {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url(../assets/medilinkPC/info1.png) center center no-repeat;
  background-size: 18px 18px;
  min-width: 18px;
  margin-right: 5px;
  position: relative;
}

.downicon {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url(../assets/medilinkPC/upload.png) center center no-repeat;
  background-size: 18px 18px;
  min-width: 18px;
  margin-right: 5px;
  top: 3px;
  position: relative;
}
.flex_n {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  span {
    &:nth-child(1) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 80%;
      display: inline-block;
    }
  }
  a {
    white-space: nowrap;
  }
}
</style>

<script>
import api from "@/utils/api";
import applyjs from "./js/applyP.js";
import { log } from "util";
import moment from "moment";
let timeout;
export default {
  data() {
    return {
      imgVisible: false,
      showImgList: [],
      baseImg: "",
      visible: false,
      steps: [
        {
          step: "1",
          text: this.$t("preAuth.sickInfo"),
          icon: require("../assets/medilinkPC/step_1_finish.png"),
          arrow: ">",
          process: true,
          arrowBlue: false
        },
        {
          step: "2",
          text: this.$t("claimStep[2]"),
          icon: require("../assets/medilinkPC/step_2_unfinish.png"),
          arrow: ">",
          process: false,
          arrowBlue: false
        },
        {
          step: "3",
          text: this.$t("claimStep[3]"),
          icon: require("../assets/medilinkPC/step_3_unfinish.png"),
          arrow: "",
          process: false,
          arrowBlue: false
        }
      ],
      columns: [
        {
          title: "",
          width: "30px"
          // scopedSlots: { customRender: 'select' },
        },
        {
          title: this.$t("bankInfo[0]"),
          // dataIndex: 'banknm',
          scopedSlots: { customRender: "banknm" }
        },
        {
          title: this.$t("bankInfo[1]"),
          dataIndex: "bankdetail"
        },
        {
          title: this.$t("bankInfo[2]"),
          dataIndex: "bankaccno"
        },
        {
          title: this.$t("bankInfo[3]"),
          scopedSlots: { customRender: "do" }
        }
      ],
      remark: "",
      stepActive: 1,
      baseInfo: {},
      categoryList: [
        {
          value: "OP",
          text: this.$t("category[0]")
        },
        {
          value: "IP",
          text: this.$t("category[1]")
        }
      ],
      hospitalName: "",
      amount: "",
      isAddCard: false,
      bankList: [],
      mainCard: {},
      memberNo: "",
      // cityCode: '',
      // bankName: '',
      area: "",
      // branchCode: '',
      formData: {
        name: "",
        idNumber: "",
        bankName: "",
        bankCode: "",
        city: "",
        citycode: "",
        bankNo: "",
        bankDetail: "",
        bankDailCode: "",
        memberNo: ""
        // fileList: []
      },
      bankData: [],
      bankValue: [],
      bankCardInfoList: [],
      addressData: [],
      addressValue: [],
      areaInfoList: [],
      branchData: [],
      branchValue: [],
      branchBankInfoList: [],
      uploadFileList: [],
      // submitData: {},
      category: "OP",
      date: null,
      coverage: "",
      value: [],
      fetching: false,
      fetchData: [],
      language: "",
      queryForm: {
        provider_name: "",
        fromRowNum: 1,
        toRowNum: 10,
        language: "CHINAESE"
      },
      fetchData: [],
      bankInfo: {},
      fileList: [],
      cardNo: "",
      policyList: [],
      oriPolicyList: [],
      policyObj: {}, // 保单号和生效日期
      cov_catg: "", // 保险责任
      relativeTxt: "",
      insuredList: [],
      selectedRowKeys: [],
      agreeFlag: false,
      visibleRule: false,
      isLoading: false,
      policyChoose: false,
      effectivePolicyList: [],
      hisPolicyList: [],
      userInfo: {},
      judgefetching: false,
      fetchJudgeData: [],
      judgevalue: undefined,
      estLos: "",
      estBills: "",
      visibleDes: false,
      fileListUpload: []
    };
  },
  filters: {
    filterData(val, data) {
      if (val === "" || val === null || val === undefined) {
        return "--";
      } else {
        let textCon = "";
        data.map(item => {
          if (item.value == val) {
            textCon = item.text;
          }
        });
        return textCon;
      }
    }
  },
  methods: {
    ...applyjs,
    moment,
    disabledDate(currentDate) {
      return currentDate && currentDate < moment();
    }
  },
  mounted() {
    if (this.$i18n.locale == "zh-cn") {
      this.language = "CHINAESE";
      this.queryForm.language = "CHINAESE";
    } else {
      this.language = "ENGLISH";
      this.queryForm.language = "ENGLISH";
    }
    this.date = moment()
      .add(1, "days")
      .format("YYYY-MM-DD");
    this.getcalimAppBaseIfo();
    this.uploadFileList = [];
    localStorage.setItem("uploadParams", JSON.stringify([]));
    this.queryEffectivePolicy();
    this.queryHisPolicy();
  }
};
</script>
